export const GET_CITIES_CONTROL = 'GET_CITIES_CONTROL';
export const GET_CITIES_CONTROL_ERROR = 'GET_CITIES_CONTROL_ERROR';
export const GET_CITIES_CONTROL_CONFIG = 'GET_CITIES_CONTROL';
export const GET_CITIES_CONTROL_CONFIG_ERROR = 'GET_CITIES_CONTROL_ERROR';
export const SET_CITIES_TRIGGERS = 'SET_CITIES_TRIGGERS';